;
define("product_views_option_currency.tpl", function(){});

